import { handleTrack } from '../../utils/tracker';
import { SelectInput } from '../Calculators/calculator-revamp/components/form-components/SelectBox';
import { usePaytaxCalcContext } from './context';
import { BasicDetailsdata } from './tax-calculator-constants';
import { CALCULATOR_TAB_PROPS } from './types';
import { useDebouncedTaxCalculation } from './use-debounce-calcultion';

const BasicDetails = ({
  setInputData,
  inputTabData,
  setTaxResult,
}: CALCULATOR_TAB_PROPS) => {
  const { setFinancialYear } = usePaytaxCalcContext();

  const { setCurrentState } = useDebouncedTaxCalculation(
    inputTabData,
    setTaxResult,
    0
  );
  const handleChange = (key: string, value: number | string) => {
    setCurrentState(String(value));
    handleTrack({ label: `Basic_details_${key}` });
    setInputData?.((prev) => ({ ...prev, [key]: value }));
    setFinancialYear(value as string);
  };

  return (
    <>
      <div className="flex gap-12  sm:block font-medium">
        {BasicDetailsdata?.map((props, index) => {
          return (
            <div key={index} className="w-full">
              <SelectInput
                {...props}
                value={`${inputTabData?.[props.id]}`}
                onChange={handleChange}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default BasicDetails;
